import { useEffect, useState } from "react";

/**
 * CSS @media 와 동일하게 viewport 변경에 반응하는 훅.
 * 데스크탑/모바일 분기 렌더링에 사용.
 *
 * 예시:
 *   const isDesktop = useMediaQuery("(min-width: 1024px)");
 */
export default function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === "undefined") return;
    const mq = window.matchMedia(query);
    const handler = (e) => setMatches(e.matches);
    // 신/구 브라우저 호환
    if (mq.addEventListener) {
      mq.addEventListener("change", handler);
      return () => mq.removeEventListener("change", handler);
    }
    mq.addListener(handler);
    return () => mq.removeListener(handler);
  }, [query]);

  return matches;
}

/** 자주 쓰이는 breakpoint helper */
export function useIsDesktop() {
  return useMediaQuery("(min-width: 1024px)");
}
